

const Footer = () => {

    return (

        <div className='py-3'>
            <p className='m-0' style={{ fontSize: '12px', opacity: 0.75 }}>Miguel García y Facundo Francou - Todos los derechos reservados 2023</p>
        </div>

    )
}

export default Footer;